import styled from 'styled-components';

import { Text } from '../../../../../../../components';
import { ThemeProp } from '../../../../../../../theme/Themes';

export const Container = styled.div`
  display: flex;
  gap: 0.75rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    flex-direction: column;
  }
`;

export const OptionContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 1rem;
  gap: 0.62rem;
  border-radius: 0.5rem;
  border: 1px solid ${(props: ThemeProp) => props.theme.colors.greyscale.c700};
  cursor: pointer;

  &:hover {
    background-color: ${(props: ThemeProp) => props.theme.colors.primary.c900};
  }

  &:active {
    background-color: ${(props: ThemeProp) => props.theme.colors.primary.c800};
  }

  svg {
    width: 1.875rem;
    height: 1.875rem;
    path {
      stroke-width: 1.2px;
    }
    stroke: ${(props: ThemeProp) => props.theme.colors.white};
  }
`;

export const OptionText = styled(Text)`
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.lineHeight};
`;
